import React from 'react';

const Loading = () => {
    
    return (
        <span>Loading...</span>
    );
}

export default Loading;